package com.essntl.core.quickbooks.data

import kotlinx.serialization.Serializable

@Serializable
data class QuickbookUpdateRequest(
    val SyncToken: String,
    val Id: String,
    val sparse: Boolean,
    val Line: List<QuickbooksInvoiceRequest.Line>,
)